module.exports = __webpack_public_path__ + "img/multimedia.fe7280d3.svg";